import gql from 'graphql-tag';
import { MESSAGE_BOILERPLATE_REQUEST_FIELDS } from '@/store/messageBoilerplateFragment';

/**
 * Project fields a mail of the block project-email reads: placeholders, recipient and prerequisite
 * hints. Reloaded with the attachment size on every template selection, so a mail never uses
 * values saved by another block after the page was loaded.
 */
export const PROJECT_EMAIL_EXCERPT_FIELDS = gql`
  fragment projectEmailExcerptFields on ProjectEmailBlock {
    id
    number
    customer {
      salutation
      firstname
      lastname
      zip
      city
      email
    }
    powerCompany {
      _id
      registrationEmail
    }
    netRegistrationRequirementsFullfilledState
    operationRegistrationRequirementsFullfilledState
    netRegistrationAttachmentsBuildState
    operationRegistrationAttachmentsBuildState
  }
`;

/**
 * Data of the block project-email ("E-Mail"): the excerpt plus the templates. Read through
 * `Project.blocks.email`, which checks the block's read permission.
 */
export const PROJECT_EMAIL_FIELDS = gql`
  fragment projectEmailFields on ProjectEmailBlock {
    ...projectEmailExcerptFields
    messageBoilerplates {
      ...messageBoilerplateFields
    }
  }
  ${PROJECT_EMAIL_EXCERPT_FIELDS}
  ${MESSAGE_BOILERPLATE_REQUEST_FIELDS}
`;
